import { ACCOUNT_SERVICE_URI, BIO_SERVICE_URI } from 'library-@/config/apiConfig';

const EMAIL_ALERT_CONFIG = { pattern: /\/email-alert-api\/.+/, version: '1.0' };
const ANALYSIS_CONFIG = { pattern: /\/analysis-api\/.+/, version: '2.0' };
const CORE_BASIC_CONFIG = { pattern: /\/core-basic-api\/.+/, version: '2.0' };
const CORE_SEARCH_CONFIG = { pattern: /\/core-search-api\/.+/, version: '2.0' };
const LANDSCAPE_CONFIG = { pattern: /\/landscape-api\/.+/, version: '2.0' };
const WORKSPACE_CONFIG = { pattern: /workspace\/web\/.+/, version: '2.0' };
const MARKETPLACE_CONFIG = { pattern: /\/marketplace-api\/.+/, version: '1.0' };
const INSIGHTS_CONFIG = { pattern: /insights-api\/.+/, version: '1.0' };
const S_ANALYSIS_CONFIG = { pattern: /s-analytics-basic\/.+/, version: '1.0' };
const PASSPORT_PRIVILEGE_CONFIG = { pattern: /user\/tips\/privilege_renew/, version: '1.0' };
const CHEMICAL_CONFIG = { pattern: /chemical-user\/.+/, version: '1.0' };
const DISCOVERY_CONFIG = { pattern: /discovery-api\/.+/, version: '2.0' };

const LIFE_SCIENCE_SERVICE_CONFIG = {
    pattern: new RegExp(`${BIO_SERVICE_URI}\/life-science-search-web`),
    version: '1.0'
};

const ACCOUNT_SERVICE_CONFIG = {
    pattern: new RegExp(`${ACCOUNT_SERVICE_URI}`),
    version: '1.0'
};


export const PRESETS_TOKEN_BASE_HISTORY = {
    name: 'history',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        CHEMICAL_CONFIG,
        DISCOVERY_CONFIG
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_ANALYSIS = {
    name: 'analysis',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_CITATION = {
    name: 'citation',
    excludesUrlRegExps: [
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_MATRIX = {
    name: 'matrix',
    excludesUrlRegExps: [
        ANALYSIS_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_NPL = {
    name: 'npl',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        /^\/\w+-api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_CASE = {
    name: 'case',
    excludesUrlRegExps: [
        /core-basic-api/,
        /core-search-api/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_SEARCH = {
    name: 'search',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        WORKSPACE_CONFIG,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG,
        { pattern: /^\/rd-api\/.+/, version: '2.0' },
        /^\/(\w+-)+api\/.+/,
        /http(s)?:\/\//
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_PATENT_VIEW = {
    name: 'patent-view',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        EMAIL_ALERT_CONFIG,
        LIFE_SCIENCE_SERVICE_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ],
    apiVersion: '1.0'
};

export const PRESETS_TOKEN_BASE_WORKSPACE = {
    name: 'workspace',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        MARKETPLACE_CONFIG,
        ANALYSIS_CONFIG,
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        CORE_SEARCH_CONFIG,
        { pattern: /^\/(\w+-)+api\/.+/, version: '1.0' },
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_MARKETPLACE = {
    name: 'marketplace',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        WORKSPACE_CONFIG,
        MARKETPLACE_CONFIG,
        { pattern: /^\/(\w+-)+api\/.+/, version: '1.0' },
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '1.0'
};

export const PRESETS_TOKEN_BASE_EXPORT = {
    name: 'export',
    excludesUrlRegExps: [
        /^\/(\w+-)+api\/.+/,
        CORE_BASIC_CONFIG,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_INTEGRATE = {
    name: 'integrate',
    excludesUrlRegExps: [
        { pattern: /^\/core-basic-api\/analytics\/wechat\/unbind/, version: '1.0' },
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        EMAIL_ALERT_CONFIG,
        INSIGHTS_CONFIG,
        S_ANALYSIS_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_FUNDATION = {
    name: 'fundation',
    excludesUrlRegExps: [
        /^\/(\w+-)+api\/.+/,
        /http(s)?\:\/\//,
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_SEARCH_RESULT = {
    name: 'search-result',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        EMAIL_ALERT_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG,
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_LANDSCAPE = {
    name: 'landscape',
    excludesUrlRegExps: [
        LANDSCAPE_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ],
    apiVersion: '2.0'
};


export const PRESETS_TOKEN_BASE_SEARCH_IMAGE_RESULT = {
    name: 'search-image-result',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        WORKSPACE_CONFIG,
        CORE_SEARCH_CONFIG,
        /http(s?)\:\/\/.*\.png/, // 排除图片请求(http://patsnap-image120.cdn.zhihuiya.com/US/D8/38/58/0/00000001_0001.png?xxxxx)
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG
    ]
};

export const PRESETS_TOKEN_BASE_PAPER = {
    name: 'paper',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        /^\/(\w+-)+api\/.+/,
        /http(s?)\:\/\//,
        /\/\//
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_GNAME = {
    name: 'gname',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        /^\/(\w+-)+api\/.+/,
        /http(s?)\:\/\//,
        /\/\//
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_EMAIL_ALERT = {
    name: 'email-alert',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        WORKSPACE_CONFIG,
        { pattern: /^\/rd-api\/.+/, version: '2.0' },
        /^\/(\w+-)+api\/.+/,
        /http(s)?:\/\//
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_HOMEPAGE = {
    name: 'homepage',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        EMAIL_ALERT_CONFIG,
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        CHEMICAL_CONFIG,
        DISCOVERY_CONFIG,
        /^\/(\w+-)+api\/.+/,
        /http(s?)\:\/\//,
        /\/\//
    ],
    apiVersion: '2.0'
};

export const PRESETS_TOKEN_BASE_AI_LAB = {
    name: 'ai-lab',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        CORE_BASIC_CONFIG,
        CORE_SEARCH_CONFIG,
        EMAIL_ALERT_CONFIG,
        /^\/(\w+-)+api\/.+/,
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG,
    ],
    apiVersion: '2.0'
};
